<script setup>
import { onMounted } from 'vue'
import { printResponseProperty } from '@/libs/utils/questions/radio_checkbox.js'

import QuestionGroupComponent from '@/components/CompiledPoll/QuestionGroupComponent.vue'

const props = defineProps(['handleAnswer', 'compiledPoll', 'question']);
const answerNote = defineModel('answerNote');
const answerValue = defineModel('answerValue')

onMounted(() => {
  props.compiledPoll['answers'].forEach(el => {
    if (el['questionReference'] === props.question['reference']) {
      if (el['note']) answerNote.value = el['note'];
      if (el['questionReference'] === props.question['reference']) {
        answerValue.value = el['value'];
        if (props.handleAnswer !== null) {
          props.handleAnswer(props.question['reference'], answerValue.value, false);
        }
      }
    }
  });
});

function selectValueF(value) {
  this.selectedValues = [];
  this.selectedValues.push(value);
  if (props.handleAnswer !== null) {
    props.handleAnswer(props.question['reference'], value['value'], false, answerNote.value);
  }
}

function checkQuestionGroupDependentQuestionCondition(childQuestionGroup) {
  let condition = childQuestionGroup['dependentQuestionCondition']
  let found = false;
  this.selectedValues.map((el) => {
    if (condition && condition === el.value) {
      found = true;
    }
  });

  if (!found) {
    resetAnswersChildQuestionGroup(childQuestionGroup)
  }
  return found;
}

function resetAnswersChildQuestionGroup(childQuestionGroup) {
  let questions = childQuestionGroup['questions'];
  questions.forEach((question) => {
    if (props.handleAnswer !== null) {
      props.handleAnswer(question['reference'], null, true);
    }
    if (question['childQuestionGroups'] && question['childQuestionGroups'].length > 0) {
      question['childQuestionGroups'].forEach((group) => {
        resetAnswersChildQuestionGroup(group);
      })
    }
  })
}
</script>

<template>
  <div>
    <label :for="'textQuestion'+question['id']" :class="'form-label'+ (question.required ? ' fw-bold ' : '')">{{ question.text }} {{ question.required ? '*' : '' }}</label>
    <div class="form-check" v-for="(selectValue, index) in question['additionalProperties']['select_values']" :key="selectValue.value">
      <div>
        <input :disabled="handleAnswer === null"
               :required="question.required"
               class="form-check-input"
               type="radio"
               :name="question['id']"
               :checked="answerValue === selectValue.value"
               :id="selectValue['value']+'_'+index"
               @change="selectValueF(selectValue, $event)">
        <label class="form-check-label" :for="selectValue['value']+'_'+index">
          {{ selectValue['label'] }}
        </label>
      </div>
      <template v-if="selectValue?.properties">
        <div v-for="(property) in selectValue.properties"
             class="form-text"
        >
          {{ printResponseProperty(property) }}
        </div>
      </template>
    </div>
    <small v-if="question.helper" class="form-text">{{ question.helper }}</small>

    <div v-for="childQuestionGroup in question['childQuestionGroups']" :key="childQuestionGroup['id']">
      <div class="mt-2" v-if="checkQuestionGroupDependentQuestionCondition(childQuestionGroup)">
        <question-group-component :handle-answer="handleAnswer" :question-group="childQuestionGroup"></question-group-component>
      </div>
    </div>

    <div v-if="question.hasNote" class="pt-2">
      <div class="pe-2">
        <label :for="'noteQuestion'+question['id']" class="form-label">Note</label>
        <textarea @change="selectValueF"
                  class="form-control" rows="2" placeholder="Inserisci note"
                  :id="'noteQuestion'+question['id']"
                  v-model="answerNote"
                  :disabled="!(compiledPoll['state'] !== 'filled' && handleAnswer !== null)"></textarea>
      </div>
    </div>

  </div>
</template>

<style scoped lang="scss">

</style>
